import { AVAILABLE_WORLDS } from '../../../../languages/constants';
import imgEuroLeft from './assets/euro_left.svg';
import imgEuroRight from './assets/euro_right.svg';
import imgLeft from './assets/left.svg';
import imgRight from './assets/right.svg';

export const CONFIG = {
    [AVAILABLE_WORLDS.ES]: {
        imgLeft,
        imgRight,
        text: () => 'Comparte tus materiales en eduki y te regalamos 25€ en créditos'
    },
    [AVAILABLE_WORLDS.FR]: {
        imgLeft: imgEuroLeft,
        imgRight: imgEuroRight,
        text: () => 'Partage des ressources pédagogiques et obtiens 25 €'
    },
    [AVAILABLE_WORLDS.DE]: {
        imgLeft: imgEuroLeft,
        imgRight: imgEuroRight,
        text: () => 'Material teilen & 25 € sichern'
    },
    [AVAILABLE_WORLDS.IT]: {
        imgLeft: imgEuroLeft,
        imgRight: imgEuroRight,
        text: () => 'Carica i tuoi materiali didattici e ottieni 25€ di credito'
    },
    [AVAILABLE_WORLDS.GR]: {
        imgLeft: imgEuroLeft,
        imgRight: imgEuroRight,
        text: () => 'Ανέβασε το εκπαιδευτικό υλικό σου και κέρδισε 25€ σε πιστωτικές μονάδες'
    }
};
